import { render, staticRenderFns } from "./RecognitionsCardItem.vue?vue&type=template&id=cbb699ac&"
import script from "./RecognitionsCardItem.vue?vue&type=script&lang=js&"
export * from "./RecognitionsCardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports